<template>
	<div class="login">
		<template v-if="authorized">
			<div class="login__authorized">
				<div class="login__text">Вы авторизованы как {{ user.first_name }} {{ user.last_name }}.</div>

				<Button :type="'text'" :value="'Выйти'" :paint="'blue'" @click="logout" />
			</div>
		</template>

		<template v-else>
			<div class="login__wrapper">
				<img class="login__logo" src="@/assets/images/logo.svg" alt="" />
				<div class="login__title">Вход</div>

				<form class="login__form" @submit.prevent>
					<div class="login__form-body">
						<div class="login__form-block" v-if="type == 'email'">
							<div class="login__form-title">Электронная почта</div>
							<Input
								:type="email.type"
								:name="email.name"
								:value="email.value"
								:status="email.status"
								autocomplete
								@touchstart="changeLoginEmail"
								@focus="changeLoginEmail"
								@input="changeLoginEmail"
								@paste="changeLoginEmail"
								@change="changeLoginEmail"
							/>
							<span class="login__form-error" v-if="email.error">{{ email.error }}</span>
						</div>
						<div class="login__form-block" v-else-if="type == 'phone'">
							<div class="login__form-title">Телефон</div>
							<Input
								:type="phone.type"
								:name="phone.name"
								:value="phone.value"
								:status="phone.status"
								:mask="'phone'"
								@iptinput="changeLoginPhone"
							/>
							<span class="login__form-error" v-if="phone.error">{{ phone.error }}</span>
						</div>

						<div class="login__form-block">
							<div class="login__form-title">Пароль</div>
							<Input
								:type="password.type"
								:name="password.name"
								:value="password.value"
								:status="password.status"
								autocomplete
								readonly
								@touchstart="changeLoginPassword"
								@focus="changeLoginPassword"
								@input="changeLoginPassword"
								@paste="changeLoginPassword"
								@change="changeLoginPassword"
							/>
							<span class="login__form-error" v-if="password.error">{{ password.error }}</span>
						</div>
					</div>
					<div class="login__form-footer">
						<Button :type="'text'" :value="'Войти'" :paint="'blue'" :disabled="!validation" @click="login" />
					</div>

					<div class="login__form-type" @click="changeLoginType">
						Войти по {{ type == "email" ? "номеру телефона" : "электронной почте" }}
					</div>
				</form>

				<div class="login__notice">
					Если у вас нет учетной записи в системе Airwet, пройдите
					<a class="login__notice-link" href="#" @click.prevent="goToRegister">Регистрацию</a>, чтобы ее создать!
				</div>
				<div class="login__notice">
					Для восстановления пароля перейдите по
					<a class="login__notice-link" href="#" @click.prevent="goToRecover">ссылке</a>.
				</div>
				<div class="login__notice">
					Для ознакомления с возможностями сервиса используйте
					<a class="login__notice-link" href="#" @click.prevent="goToDemo">демонстрационную учетную запись</a>.
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from "vuex";
	import validator from "../../mixins/validator.js";

	import Button from "../components/Button.vue";
	import Input from "../components/Input.vue";

	export default {
		name: "Login",
		components: {
			Button,
			Input,
		},
		data() {
			return {
				type: "email",
				email: {
					type: "email",
					name: "email",
					value: null,
					error: null,
					status: "default",
				},
				phone: {
					type: "tel",
					name: "phone",
					value: null,
					error: null,
					status: "default",
				},
				identifier: null,
				password: {
					type: "password",
					name: "password",
					value: null,
					error: null,
					status: "default",
				},
				authorized: false,
			};
		},
		computed: {
			...mapGetters({
				user: "getAuthorizationUser",
			}),

			validation() {
				let isValid = false;

				if (this.type == "email") {
					if (this.email.status == "valid" && this.password.status == "valid") isValid = true;
				} else if (this.type == "phone" && this.password.status == "valid") {
					if (this.phone.status == "valid") isValid = true;
				}

				return isValid;
			},
		},
		methods: {
			...mapMutations(["handleAuthorizationChanges"]),
			...mapActions(["loginAuthorization", "logoutAuthorization"]),

			/* INIT FUNCTIONS */
			initLoginView(token) {
				if (token) {
					this.authorized = true;
					console.log("authorized");
				} else {
					this.authorized = false;
					console.log("not authorized");
				}
			},

			/* EVENT HANDLERS */
			handleChange(event) {
				let payload = {
					event: event.type,
					name: event.target.getAttribute("name"),
					value: event.target.value,
				};

				if (event.type === "focus" || event.type === "touchstart") {
					event.target.removeAttribute("readonly");
				}

				this.handleAuthorizationChanges(payload);
			},
			changeLoginEmail(event) {
				if (event.type === "change" || event.type === "paste" || event.type === "input") {
					this.email.value = event.target.value;
					this.identifier = event.target.value;

					if (!this.validator(this.email.value, "email")) {
						this.email.error = "Неверный формат электронной почты";
						this.email.status = "invalid";
					} else {
						this.email.error = null;
						this.email.status = "valid";
					}
				}

				if (event.type === "focus" || event.type === "touchstart") {
					event.target.removeAttribute("readonly");
				}
			},
			changeLoginPhone(event) {
				if (event.type === "change" || event.type === "paste" || event.type === "input") {
					this.phone.value = event.target.value;
					this.identifier = event.target.value;

					if (!this.validator(this.phone.value, "phone")) {
						this.phone.error = "Неверный формат телефонного номера";
						this.phone.status = "invalid";
					} else {
						this.phone.error = null;
						this.phone.status = "valid";
					}
				}

				if (event.type === "focus" || event.type === "touchstart") {
					event.target.removeAttribute("readonly");
				}
			},
			changeLoginPassword(event) {
				if (event.type === "change" || event.type === "paste" || event.type === "input") {
					this.password.value = event.target.value;

					if (!this.validator(this.password.value, "password")) {
						this.password.error = "Не менее 6 символов, строчные и заглавные буквы, цифры";
						this.password.status = "invalid";
					} else {
						this.password.error = null;
						this.password.status = "valid";
					}
				}

				if (event.type === "focus" || event.type === "touchstart") {
					event.target.removeAttribute("readonly");
				}
			},
			changeLoginType() {
				this.identifier = null;
				this.password.value = null;
				this.password.error = null;
				this.password.status = "default";

				if (this.type == "email") {
					this.type = "phone";

					this.email.value = null;
					this.email.error = null;
					this.email.status = "default";
				} else if (this.type == "phone") {
					this.type = "email";

					this.phone.value = null;
					this.phone.error = null;
					this.phone.status = "default";
				}
			},

			/* SPECIAL HANDLERS */
			goToRegister() {
				this.$router.push("/register");
			},
			goToRecover() {
				this.$router.push("/recover");
			},
			goToDemo() {
				window.location.href = "https://demo.airwet.app";
			},
			login() {
				if (this.validation) {
					let user = {
						data: {
							identifier: this.identifier,
							password: this.password.value,
						},
					};

					this.loginAuthorization(user);
				}
			},
			logout() {
				this.logoutAuthorization();
			},
		},
		created() {
			this.initLoginView(this.user.token);
			//this.logoutAuthorization();
		},
		watch: {
			"user.token": function (newVal) {
				this.initLoginView(newVal);
			},
		},
		mixins: [validator],
	};
</script>

<style lang="scss" scoped>
	.login {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		padding-bottom: 20px;

		@include mediaquery(md) {
			min-height: calc(100vh - 20px);
		}

		&__authorized {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100%;
		}

		&__text {
			margin-bottom: 10px;
		}

		&__wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100%;

			@include mediaquery(sm) {
				width: 400px;
			}
		}

		&__logo {
			width: 50px;
			margin-bottom: 24px;

			@include mediaquery(sm) {
				margin-bottom: 44px;
			}
		}

		&__title {
			width: 100%;
			margin-bottom: 20px;
			text-transform: uppercase;
			text-align: center;
			font-size: 24px;
		}

		&__form {
			@include base;

			width: 100%;
			padding: 20px;

			@include mediaquery(sm) {
				padding: 46px 40px 25px;
			}

			&-block {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				margin-bottom: 10px;
				position: relative;

				&:last-of-type {
					margin-bottom: 0;
				}
			}

			&-subblock {
				display: flex;
				align-items: center;
			}

			&-title {
				@include title;
			}

			&-error {
				position: absolute;
				top: 100%;
				font-size: 9px;
				color: #ff8068;
			}

			&-link {
				font-size: 12px;
				color: #41c6eb;
			}

			&-footer {
				display: flex;
				flex-direction: column;
				margin-top: 20px;

				@include mediaquery(sm) {
					flex-direction: row;
					justify-content: space-between;
				}

				button {
					width: 100%;
				}
			}

			&-footer2 {
				display: flex;
				flex-direction: column;
				margin-top: 20px;
				padding-top: 20px;
				border-top: 1px solid #dcdcdc;

				@include mediaquery(sm) {
					justify-content: space-between;
				}

				button {
					width: 100%;

					&:first-of-type {
						margin-bottom: 10px;
					}
				}
			}

			&-errors {
				margin-top: 10px;
				font-size: 12px;
				color: #ff8068;
			}

			&-type {
				margin-top: 15px;
				font-size: 14px;
				cursor: pointer;
				text-align: center;
				user-select: none;

				&:hover {
					color: #41c6eb;
				}
			}
		}

		&__notice {
			font-size: 12px;
			margin-top: 16px;
			text-align: center;

			&-link {
				color: #41c6eb;
			}
		}
	}
</style>
